import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22d4ec67"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "order-status fw600" }
const _hoisted_3 = { class: "status-tips" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "copy",
  id: "copyItem"
}, "复制", -1))
const _hoisted_5 = {
  key: 0,
  class: "form-footer xag-page__footer device-replace-button-wrap"
}
const _hoisted_6 = { class: "button-wrap xag-flex-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { useAppPay } from '@/compositions/usePay'
import { useClipboard } from '@/compositions/common'
import { commonErrorHandle, getErrorMessage } from '@/utils/error-handle'
import { Toast, PullRefresh, Button, Dialog } from 'vant'
import { ref, Ref, computed, onMounted } from 'vue'
import { useOrderApply } from '@/compositions/invoice/index'
import {
  ServiceBillDetail,
  ConfirmPayOrderResult,
  ConfirmPayServiceChargePrams,
} from '@/types/malfunction-repair'
import {
  confirmPayServiceCharge,
  checkServiceChargePayStatus,
  getserviceChargeDetail,
  submitServiceChargeInvoice,
} from '@/apis/malfunction-repair'
import {
  showToastLoading,
  showNormalToast,
  showToastSuccess,
  showConfirmModal,
  clearToast,
} from '@/utils/tools'
import RepairBillBlock from './components/service-bill/detail-bill-block.vue'
import wx from 'weixin-js-sdk'
import AppHeader from '@/components/Header.vue'
import BehalfPay from '@/components/pay/behalf-pay.vue'
import OrderInoviceApply from '@/components/invoice/order-inovice-apply.vue'
import { ServiceChargeRuleMap, ServiceChargeStatusColorMap } from '@/defination/malfunction-repair'
import { useMalfunctionRepairStore } from '@/compositions/malfunction-repair'

import { defineComponent } from 'vue'
const __default__ = defineComponent({
  name: 'service-bill-detail',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { removeServiceOrderKeepAlive, removeFaultOrderListItemKeepAlive } =
  useMalfunctionRepairStore()
const $router = useRouter()
const $route = useRoute()
const $store = useStore()
const serviceGuid = $route.query.serviceGuid as string
const behalfPayDialogVisible = ref(false)
const confirmPayInfo: Ref<ConfirmPayOrderResult | null> = ref(null)
const confirmPayParams: Ref<ConfirmPayServiceChargePrams | null> = ref(null)
const isMiniProgram = computed(() => {
  return $store.getters.isMiniProgram
})
let timeId: number
const guid = $route.query.guid as string
const refreshing = ref(false)
const behalfStatusCheckHandle: Ref<() => Promise<boolean> | null> = ref(null)
const {
  invoiceData,
  scrollToInvoiceDom,
  invoiceDomInit,
  changeHandle: invoiceChangeHandle,
  getOrderInvocieSubmitParams,
  verify: invoiceVerify,
} = useOrderApply()
let detail: Ref<null | ServiceBillDetail> = ref({
  statusColor: '',
  sn: '',
  status: '',
  statusText: '',
  billInfo: {
    sum: '',
    billArr: [],
  },
  guid: '',
  invoice_apply: null,
})
const { initClipboard } = useClipboard({
  text: () => detail.value?.sn,
})
const { compatibleWechatAndCmdPay, judgeCanUseMiniProgramPay } = useAppPay()

let canPay = computed(() => {
  return detail.value.status === 'WAIT_PAY'
})

function handleSearchOrderPayStatus(pay_order_no: string, immediately = false) {
  // 查询单据支付状态
  let i = 0
  let searching = false
  function handleFn() {
    showToastLoading({
      message: '支付结果查询中',
    })
    if (i >= 12) {
      clearInterval(timeId)
      clearToast()
      Dialog.confirm({
        title: '查询结果失败',
        message: `支付订单号${pay_order_no}，请尝试继续校验，如需帮助请联系客服：400-780-3131`,
        confirmButtonText: '重新查询',
        cancelButtonText: '取消查询',
        className: 'reserve-dialog',
        width: 304,
      })
        .then(async () => {
          try {
            handleSearchOrderPayStatus(pay_order_no, true)
          } catch (error: any) {
            Dialog.close()
          }
        })
        .catch(() => {
          Dialog.close()
        })
    }
    if (searching) {
      return
    }
    searching = true
    checkServiceChargePayStatus(pay_order_no)
      .then((result) => {
        if (result.status === 2) {
          clearToast()
          // 跳转到支付成功页面
          clearInterval(timeId)
          showToastSuccess('支付成功')
          removeServiceOrderKeepAlive()
          removeFaultOrderListItemKeepAlive()
          setTimeout(() => {
            $router.go(-1)
          }, 500)
        }
      })
      .catch((error) => {
        console.log('error', error)
      })
      .finally(() => {
        searching = false
        i++
      })
  }
  if (immediately) {
    handleFn()
  }
  //
  timeId = setInterval(async () => {
    // 如果查询时间超过1分钟 那么停止查询并提示
    handleFn()
  }, 5000)
}
// 支付成功页面
const getCbPageUrl = (): string => {
  return `/malfunction-repair/pay-success/${detail?.value.sn}/${serviceGuid}/${detail.value.billInfo.sum}/${detail.value.guid}/serviceCharge`
}
async function beforePayHandle(mode: string) {
  if (!invoiceVerify()) {
    return
  }
  try {
    await showConfirmModal({
      title: '提示',
      message: '是否确认支付',
      className: 'nongfu-dialog-confirm-class nongfu-dialog-message-center',
      cancelButtonText: '取消',
      confirmButtonText: '确定',
    })
  } catch (error) {
    return
  }
  try {
    confirmPayInfo.value ? '' : await getPayInfoHandle()
    payInfoHandle(mode)
  } catch (error) {
    return
  }
  return true
}

async function getPayInfoHandle() {
  // 获取支付相关信息
  const canUseCmbPay = await judgeCanUseMiniProgramPay()
  try {
    const params = {
      from: isMiniProgram.value ? 'applets' : 'app',
      payment_platform: canUseCmbPay ? 'merchants_bank' : 'wechat',
      callback_page_url: window.location.origin + getCbPageUrl(),
    }
    showToastLoading()
    const result = await confirmPayServiceCharge(guid, params)
    if (Number(result.pay_amount) !== Number(detail.value.billInfo.sum)) {
      Dialog.confirm({
        title: '提示',
        message: `订单金额已发生变化，请点击确定刷新账单页面！`,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        className: 'reserve-dialog',
        width: 304,
      })
        .then(async () => {
          try {
            initPageDetail()
          } catch (error: any) {
            Dialog.close()
          }
        })
        .catch(() => {
          Dialog.close()
        })
      return
    }
    clearToast()
    confirmPayInfo.value = result
    confirmPayParams.value = params
  } catch (error) {
    // 如果获取支付信息失败就刷新页面即可
    initPageDetail()
    return Promise.reject(error)
  }
}
// 更新单据发票信息
async function updateInvoiceInfoHandle(): Promise<void> {
  const data = invoiceData.value
  const params = getOrderInvocieSubmitParams()
  try {
    await submitServiceChargeInvoice(guid, params)
  } catch (error) {
    console.log('error', error)
    const message = `发票选择失败: ${getErrorMessage(error)}`
    showNormalToast(message)
  }
  return null
}
async function halfPayHandle() {
  const result = confirmPayInfo.value
  const params = confirmPayParams.value
  if (params.from === 'applets') {
    // 小程序支付
    wx.miniProgram.navigateTo({
      url: '/pages/user/pay?guid=' + result.pay_order_no,
    })
  } else {
    //appHost.onPay(result.pay_order_no)
    const userAgree = await compatibleWechatAndCmdPay(result.pay_order_no)
    userAgree && handleSearchOrderPayStatus(result.pay_order_no)
  }
}
async function behalfPayHandle() {
  // 他人代付处理逻辑
  behalfPayDialogVisible.value = true
  behalfStatusCheckHandle.value = async () => {
    try {
      const data = await checkServiceChargePayStatus(confirmPayInfo.value?.pay_order_no)
      return data.status === 2
    } catch (error) {
      return false
    }
  }
}

function payInfoHandle(mode = 'half') {
  const isBehalf = mode === 'behalf'
  const isHalf = mode === 'half'
  const result = confirmPayInfo.value
  const params = confirmPayParams.value
  if (!result.need_wechat_pay) {
    initPageDetail()
    return
  }
  if (result.pay_type == '线上支付') {
    if (isHalf) {
      // 自己支付时
      halfPayHandle()
    } else if (isBehalf) {
      behalfPayHandle()
    }
    return
  }
  if (result.pay_type == '线下支付') {
    if (result.need_wechat_pay) {
      Toast('错误，线下支付不需要微信支付！')
    } else {
      initPageDetail()
    }
  }
  removeServiceOrderKeepAlive()
  removeFaultOrderListItemKeepAlive()
}

async function initPageDetail(refresh = false) {
  if (!refresh) {
    showToastLoading()
  }
  if (invoiceData.value && invoiceData.value?.invoice_guid) {
    await updateInvoiceInfoHandle()
  }
  try {
    let getserviceChargeDetailData = await getserviceChargeDetail(guid)
    detail.value.sn = getserviceChargeDetailData.order_no
    detail.value.status = getserviceChargeDetailData.status
    detail.value.statusColor = ServiceChargeStatusColorMap.get(getserviceChargeDetailData.status)
    detail.value.statusText = getserviceChargeDetailData.status_text
    detail.value.billInfo.sum = getserviceChargeDetailData.pay_amount
    detail.value.billInfo.billArr = (getserviceChargeDetailData.details || []).map((_) => {
      return {
        title: _.service_charge_name,
        titleRule: ServiceChargeRuleMap.get(_.rule) || '',
        description: _.service_charge_rule_name,
        num: _.num,
        price: _.raw_price,
        sum: _.pay_amount,
      }
    })
    detail.value.guid = getserviceChargeDetailData.guid
    detail.value.invoice_apply = getserviceChargeDetailData.invoice_apply
    invoiceChangeHandle(detail.value.invoice_apply)
    Toast.clear()
  } catch (error) {
    Toast.clear()
    commonErrorHandle(error)
  }
  refreshing.value = false
}
function behalfPaySuccessHandle() {
  if (!behalfPayDialogVisible.value) {
    // 如果用户是已经关闭了代付弹窗的状态，不给用户支付成功响应
    return
  }
  behalfPayDialogVisible.value = false
  // 代付支付成功回调
  // 跳转到支付成功页面
  showToastSuccess('支付成功')
  removeServiceOrderKeepAlive()
  removeFaultOrderListItemKeepAlive()
  setTimeout(() => {
    $router.go(-1)
  }, 2000)
}
const onRefresh = () => {
  refreshing.value = true
  initPageDetail(true)
}
onMounted(() => {
  initPageDetail()
  initClipboard('#copyItem')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "服务费用单" }),
    _createVNode(_unref(PullRefresh), {
      modelValue: refreshing.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((refreshing).value = $event)),
      onRefresh: onRefresh,
      class: "detail-wrap"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "status-text",
              style: _normalizeStyle('color:' + _unref(detail).statusColor)
            }, _toDisplayString(_unref(detail).statusText), 5),
            _createElementVNode("div", _hoisted_3, [
              _createTextVNode(_toDisplayString(_unref(detail).sn) + " ", 1),
              _hoisted_4
            ])
          ]),
          _createVNode(RepairBillBlock, {
            class: "block-item",
            "pay-info": _unref(detail).billInfo
          }, null, 8, ["pay-info"]),
          (_unref(canPay))
            ? (_openBlock(), _createBlock(OrderInoviceApply, {
                key: 0,
                invoiceData: _unref(detail)?.invoice_apply || null,
                onInit: _unref(invoiceDomInit)
              }, null, 8, ["invoiceData", "onInit"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(BehalfPay, {
      show: behalfPayDialogVisible.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((behalfPayDialogVisible).value = $event)),
      orderNo: confirmPayInfo.value?.pay_order_no || '',
      behalfStatusCheckHandle: behalfStatusCheckHandle.value,
      onPaySuccess: behalfPaySuccessHandle
    }, null, 8, ["show", "orderNo", "behalfStatusCheckHandle"]),
    (_unref(canPay))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(Button), {
              square: "",
              class: "xa-vant-button pay-behalf",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (beforePayHandle('behalf')))
            }, {
              default: _withCtx(() => [
                _createTextVNode("找人代付")
              ]),
              _: 1
            }),
            _createVNode(_unref(Button), {
              square: "",
              type: "success",
              class: "xa-vant-button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (beforePayHandle('half')))
            }, {
              default: _withCtx(() => [
                _createTextVNode("确认支付")
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_7
  ], 64))
}
}

})